/* script for convert capitalize case of table text */
window.capitalize = (str) => {
    // Ensure we always operate on a string to avoid runtime errors
    const safeValue = (str === undefined || str === null) ? "" : String(str);
    return safeValue.toUpperCase();
  }

  window.b64DecodeUnicode = (str) => {
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

  window.b64EncodeUnicode = (str) => {
      return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
          function toSolidBytes(match, p1) {
              return String.fromCharCode('0x' + p1);
      }));
  }

window.showPopup = (e, ele)=>{
    const target = e.target;
    if(ele === "" || ele === undefined) ele = $(target).parent("tr");
    if(target.nodeName === "TD" && $(target).data("nopopup") === undefined){
        const title = $(ele).data("title");
        const message = $(ele).data("titleMessage");
        const datahref = $(ele).data("href");
        const dataedithref=$(ele).data("edithref");
        const datadeletehref=$(ele).data("deletehref");
        const dataundohref=$(ele).data("undohref");
        const datadetachlphref=$(ele).data("detach");
        const datattachlphref=$(ele).data("attach");
        const dataundostatus=$(ele).data("undostatus");
        const datarowsignature=$(ele).data("rowsignature");
        const dataAttachText=$(ele).data("attachtext");
        const datarefnr=$(ele).data("refnr");

        const modal = $("#myModal");
        try{
        const response = b64DecodeUnicode(title);
        modal.find(".modal-title").html(message);
        modal.find(".modal-main-content").html(response);
        
        // Store refnr for later initialization
        if (datarefnr) {
            modal.data('current-refnr', datarefnr);
        }
        
        // Reset all buttons first to prevent state issues from bay_popup or other modals
        modal.find(".delete-button").hide();
        modal.find(".edit-button").hide();
        modal.find(".undo-button").hide();
        modal.find(".save-button").hide();
        modal.find(".booking-request-approve").hide();
        modal.find(".booking-request-decline").hide();
        
        // Show only the buttons that are needed for this specific modal
        if(datadeletehref!=undefined) {
            modal.find(".delete-button").attr("href", datadeletehref);
            modal.find(".delete-button").show();
        }
        if(dataedithref!=undefined) {
            modal.find(".edit-button").attr("href", dataedithref);
            modal.find(".edit-button").show();
        }
        if(dataundohref!=undefined) {
            modal.find(".undo-button").attr("href", dataundohref);
            modal.find(".undo-button").show();
        }

        if (datadetachlphref !== undefined) {
            modal.find(".save-button").attr("href", datadetachlphref);
            modal.find(".save-button").attr("id", 'detachcontainer');
            modal.find(".save-button").text(dataAttachText);
            modal.find(".save-button").show();
        } else if (datattachlphref !== undefined) {
            modal.find(".save-button").attr("href", 'javascript:void(0);');
            modal.find(".save-button").attr("id", 'attachcontainer');
            modal.find(".save-button").data("rowsignature", datarowsignature);
            modal.find(".save-button").text(dataAttachText);
            modal.find(".save-button").show();
        }


        if (dataundostatus!=undefined) {
            $("#displaystatus").text(dataundostatus);
        }


        modal.modal('show');

        }catch(err){
            console.error(err)
        }
    }

}

$("#myModal").off("hidden.bs.modal").on("hidden.bs.modal", function () {
    const modal = $("#myModal");
    modal.find(".edit-button").hide();
    modal.find(".delete-button").hide();
    modal.find(".undo-button").hide();
    modal.find(".save-button").hide();
    modal.removeData('current-refnr');
    
    // Clear and reset extra booking data section
    modal.find(".extra-data-list").html('<div class="no-extra-data">No additional data</div>');
    modal.find('.modal-extra-content').hide();
    modal.find('.modal-main-content').removeClass('col-md-6').addClass('col-md-12');
    
    if (typeof resetExtraBookingDataManager === 'function') {
        resetExtraBookingDataManager();
    }
});

$("#myModal").off("shown.bs.modal").on("shown.bs.modal", function () {
    const modal = $("#myModal");
    const refnr = modal.data('current-refnr');
    
    if (refnr && typeof initExtraBookingDataManager === 'function') {
        initExtraBookingDataManager(refnr);
    }
    
    // Add click handlers for editable timestamps
    modal.find('.timestamp-editable').off('click').on('click', function(e) {
        e.stopPropagation();
        const $timestamp = $(this);
        const timestampType = $timestamp.data('timestamp-type');
        const timestampValue = $timestamp.data('timestamp-value');
        const refnr = $timestamp.data('refnr');
        const slotTimeId = $timestamp.data('slot-time-id');
        
        // Open timestamp edit modal
        openTimestampEditModal(timestampType, timestampValue, refnr, slotTimeId, $timestamp);
    });
});

// Function to open timestamp edit modal
function openTimestampEditModal(timestampType, timestampValue, refnr, slotTimeId, $timestampElement) {
    // Create a modal for editing timestamp
    const editModal = $('<div>', {
        'class': 'modal fade',
        'id': 'timestampEditModal',
        'tabindex': '-1',
        'role': 'dialog'
    });
    
    // Format the current timestamp for the datetime-local input
    // The timestampValue comes as UTC, but datetime-local input expects local time string
    const currentDate = new Date(timestampValue + ' UTC'); // Explicitly parse as UTC
    
    // Get local time components
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const hours = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const seconds = String(currentDate.getSeconds()).padStart(2, '0');
    
    // Format as local time for datetime-local input
    const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    
    // Get readable label for timestamp type from translations
    const translations = window.timestampTranslations || {};
    const typeLabels = {
        'booking': translations.timestamp_booking || 'Booking',
        'inqueue': translations.timestamp_inqueue || 'In Queue',
        'called_in': translations.timestamp_called_in || 'Called In',
        'checkin': translations.timestamp_checkin || 'Check-in',
        'checkout': translations.timestamp_checkout || 'Check-out',
        'deleted': translations.timestamp_deleted || 'Deleted',
        'queue_cleared': translations.timestamp_queue_cleared || 'Queue Cleared'
    };
    const typeLabel = typeLabels[timestampType] || timestampType;
    
    const title = (translations.edit_timestamp_title || 'Edit {type} Timestamp').replace('{type}', typeLabel);
    const modalContent = `
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">${title}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label for="timestamp-input">${translations.new_timestamp_label || 'New timestamp:'}</label>
                        <input type="datetime-local" class="form-control" id="timestamp-input" value="${formattedDateTime}" step="1">
                    </div>
                    <div class="alert alert-info">
                        <small>${translations.current_timestamp || 'Current:'} ${currentDate.toLocaleString('sv-SE', { 
                            year: 'numeric', 
                            month: '2-digit', 
                            day: '2-digit', 
                            hour: '2-digit', 
                            minute: '2-digit', 
                            second: '2-digit' 
                        })}</small>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">${translations.button_close || translations.close || 'Close'}</button>
                    <button type="button" class="btn btn-primary" id="save-timestamp">${translations.button_save || translations.save || 'Save'}</button>
                </div>
            </div>
        </div>
    `;
    
    editModal.html(modalContent);
    $('body').append(editModal);
    editModal.modal('show');
    
    // Handle save button click
    editModal.find('#save-timestamp').on('click', function() {
        const newTimestamp = editModal.find('#timestamp-input').val();
        if (!newTimestamp) {
            alert(translations.select_valid_timestamp || 'Please select a valid timestamp');
            return;
        }
        
        // Convert local datetime to UTC for storage
        // The datetime-local input returns local time, we need to convert to UTC
        const newDate = new Date(newTimestamp);
        
        // Format as UTC timestamp for database (YYYY-MM-DD HH:mm:ss)
        const year = newDate.getUTCFullYear();
        const month = String(newDate.getUTCMonth() + 1).padStart(2, '0');
        const day = String(newDate.getUTCDate()).padStart(2, '0');
        const hours = String(newDate.getUTCHours()).padStart(2, '0');
        const minutes = String(newDate.getUTCMinutes()).padStart(2, '0');
        const seconds = String(newDate.getUTCSeconds()).padStart(2, '0');
        
        const utcTimestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        
        // Send AJAX request to update timestamp
        $.ajax({
            url: '/api/update-timestamp',
            method: 'POST',
            data: {
                timestamp_type: timestampType,
                timestamp_value: utcTimestamp,
                refnr: refnr,
                slot_time_id: slotTimeId,
                _token: $('meta[name="csrf-token"]').attr('content')
            },
            success: function(response) {
                if (response.success) {
                    editModal.modal('hide');
                    
                    // Update the timestamp in the modal without reloading
                    if (response.formatted_timestamp) {
                        // Find the span element inside the timestamp paragraph that contains the actual timestamp
                        const $timestampValueSpan = $timestampElement.find('.timestamp-value');
                        
                        if ($timestampValueSpan.length) {
                            // Update only the timestamp value inside the span, keeping the label
                            $timestampValueSpan.text(response.formatted_timestamp);
                        } else {
                            // Fallback: if no span found, update the whole element
                            $timestampElement.text(response.formatted_timestamp);
                        }
                        
                        // Update the data attribute with the new UTC timestamp
                        $timestampElement.data('timestamp-value', response.new_timestamp);
                        $timestampElement.attr('data-timestamp-value', response.new_timestamp);
                        
                        // Add highlight effect to the entire paragraph
                        $timestampElement.addClass('timestamp-updated');
                        setTimeout(function() {
                            $timestampElement.removeClass('timestamp-updated');
                        }, 2000);
                        
                        // Refresh the modal content to show updated data
                        const modal = $("#myModal");
                        const refnr = modal.data('current-refnr');
                        if (refnr) {
                            // Trigger a refresh of the modal data
                            const currentRow = $(`tr[data-refnr="${refnr}"]`);
                            if (currentRow.length) {
                                currentRow.trigger('click');
                            }
                        }
                    }
                } else {
                    const errorMsg = translations.error_updating || 'Error updating:';
                    alert(errorMsg + ' ' + (response.message || ''));
                }
            },
            error: function(xhr, status, error) {
                console.error('Error updating timestamp:', error);
                alert(translations.error_updating_timestamp || 'Error updating timestamp. Please try again.');
            }
        });
    });
    
    // Remove modal from DOM after it's hidden
    editModal.on('hidden.bs.modal', function() {
        editModal.remove();
    });
}

$('#mobileAppBtn').on('click', function(e) {
    if (window.history.length > 1) {
        window.history.back();
    } else {
        window.location.href = '/'; 
    }
});

document.addEventListener('DOMContentLoaded', function() {
    // Check if this is running inside the Cordova WebView
    const mobileAppBtn = document.getElementById('mobileAppBtn');
    if (mobileAppBtn) {
        if (window.cordova) {
            // Show the button
            mobileAppBtn.style.display = 'block';
        } else {
            // Hide it (for web browser)
            mobileAppBtn.style.display = 'none';
        }
    }
});